import { render, staticRenderFns } from "./PageCategoriesGEMRCN.vue?vue&type=template&id=2c5eb030&"
import script from "./PageCategoriesGEMRCN.vue?vue&type=script&lang=js&"
export * from "./PageCategoriesGEMRCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5eb030')) {
      api.createRecord('2c5eb030', component.options)
    } else {
      api.reload('2c5eb030', component.options)
    }
    module.hot.accept("./PageCategoriesGEMRCN.vue?vue&type=template&id=2c5eb030&", function () {
      api.rerender('2c5eb030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GEMRCN/PageCategoriesGEMRCN.vue"
export default component.exports